import React, { useEffect } from 'react';
import styled from 'styled-components/macro';
import { Heading, Button, Text, Link, Box } from '@podiumhq/design-system';
import { Subheading } from 'components/Trials/styles';
import EmailField from 'components/Trials/components/FormFields/EmailField';
import PasswordField from 'components/Trials/components/FormFields/PasswordField';
import { TrialDisclaimer } from 'components/Trials/layout';
import { MEDIUM_MEDIA_QUERY_WIDTH } from 'styles';
import { PODIUM_LOGIN_URL } from 'routes/constants';
import PodiumLogo from 'components/PodiumLogo';
import { LogoWithoutText } from 'components/PodiumLogo';

const SignupContent = ({ isSubmitting, handleSubmit, isMobile }) => {
  useEffect(() => {}, [isMobile]);

  return (
    <>
      {!isMobile && (
        <Logo>
          <PodiumLogo icon={true} />
        </Logo>
      )}
      <Box
        width={isMobile ? '100%' : '50%'}
        display="flex"
        justifyContent="center"
        padding={isMobile ? '4vh 0vh 0vh 0vh' : '22vh'}
        height={isMobile ? '96vh' : '100vh'}
        position="relative"
        marginLeft={isMobile ? 'auto' : null}
        marginRight={isMobile ? 'auto' : null}
      >
        {isMobile && (
          <Logo>
            <PodiumLogo icon={true} />
          </Logo>
        )}
        <Box maxWidth="350px" minWidth={isMobile ? null : '350px'}>
          <Heading
            color="black.base"
            fontSize="2xl"
            fontWeight="semibold"
            padding={isMobile ? '48px 0px 0px 0px' : '24px 0'}
          >
            Start your 14-day free trial.
          </Heading>
          <Subheading>
            Grow faster than ever before with tools for texting customers,
            getting reviews, and making sales.
          </Subheading>

          <EmailField isSubmitting={isSubmitting} />
          <PasswordField fillColor="black.lighter" />

          <TrialDisclaimer
            mb="32px"
            linkProps={{ textDecoration: 'none', color: 'blue.base' }}
          />

          <Button
            fillColor="blue.base"
            id="trials-account-info-next-clicked"
            mb="32px"
            onClick={handleSubmit}
            size="lg"
            fontSize="lg"
            fontWeight="600"
            style={{
              display: 'block',
              width: '100%',
            }}
          >
            Start free trial
          </Button>
          <Text
            fontSize="md"
            width="215px"
            marginLeft="auto"
            marginRight="auto"
            color="black.lightest"
          >
            Already have an account?{' '}
            <Link color="blue.base" href={PODIUM_LOGIN_URL}>
              Log in
            </Link>
          </Text>
        </Box>
      </Box>
    </>
  );
};

const Logo = styled.div`
  ${LogoWithoutText} {
    position: absolute;
    z-index: 1;
    margin-top: 32px;
    margin-left: 32px;
  }

  @media (max-width: ${MEDIUM_MEDIA_QUERY_WIDTH}px) {
    ${LogoWithoutText} {
      margin-top: 0px;
      margin-left: 0px;
    }
  }
`;

export default SignupContent;
